module.exports = __webpack_public_path__ + "static/media/6-IMG_6693.89e3d7dc.JPG";